import { combineReducers } from 'redux';
import { reducer as checkboxReducer } from './checkboxReducer';
import { userAuthReducer } from './userAuthReducer';

export default combineReducers({
  checkboxReducer,
  userAuthReducer
});
